import React from "react";

function Signup() {
  return <div>Signup Page Coming Soon</div>;
}

export default Signup;
